import { resetObj } from '@/tools/util'
import { ActionType, CustomAction } from '../../global'
import { InquiryOrderItemDTO, InquiryTabCountVO } from '@/api/inquiry'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'

export interface Tag {
  label: string
  value: string
  checked: boolean
  fieldKey: 'isUrgent' | 'isExpiringSoon' | 'isExpired'
}

export interface State {
  dataSource: {
    data: InquiryOrderItemDTO[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
  checkData: InquiryOrderItemDTO[]

  tagsData: Tag[]

  countData: InquiryTabCountVO
  record: InquiryOrderItemDTO

  // 状态筛选相关状态
  statusSearchData: number

  // 导入相关状态
  importModalOpen: boolean
  importUploadList: fileFile[]
  importOriginFile?: RcFile
  importConfirmLoading: boolean
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 100,
  },
  loading: false,
  searchData: {},

  pages: {
    pageNo: 1,
    pageSize: 10,
  },
  checkData: [],

  tagsData: [
    {
      label: '急单🔥',
      value: '1',
      checked: false,
      fieldKey: 'isUrgent',
    },
    {
      label: '即将到期⚡️',
      value: '2',
      checked: false,
      fieldKey: 'isExpiringSoon',
    },
    {
      label: '已到期⚡️',
      value: '3',
      checked: false,
      fieldKey: 'isExpired',
    },
  ],

  countData: {
    unfinishedCount: 0,
    finishedCount: 0,
    totalCount: 0,
  } as InquiryTabCountVO,
  record: {} as InquiryOrderItemDTO,
  statusSearchData: 3,
  // 用户搜索相关状态

  importModalOpen: false,
  importUploadList: [],
  importOriginFile: undefined,
  importConfirmLoading: false,
}

type Action = ActionType<State> | 'getDataAction' | 'changeDataAction'

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    // 初始化数据
    case 'changeDataAction':
      return { ...action.payload }
    case 'getDataAction':
      newstate.pages.pageNo = 1
      newstate.pages.pageSize = 30
      newstate.searchData = resetObj(newstate.searchData)
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      // 搜索 重置 分页
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setCheckDataAction':
      newstate.checkData = action.payload
      return newstate

    case 'setTagsDataAction':
      newstate.tagsData = action.payload
      return newstate

    case 'setCountDataAction':
      newstate.countData = action.payload
      return newstate
    case 'setRecordAction':
      newstate.record = action.payload
      return newstate
    case 'setStatusSearchDataAction':
      newstate.statusSearchData = action.payload
      return newstate
    case 'setImportModalOpenAction':
      newstate.importModalOpen = action.payload
      return newstate
    case 'setImportUploadListAction':
      newstate.importUploadList = action.payload
      return newstate
    case 'setImportOriginFileAction':
      newstate.importOriginFile = action.payload
      return newstate
    case 'setImportConfirmLoadingAction':
      newstate.importConfirmLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

export const setRecordAction = (
  param: InquiryOrderItemDTO,
): CustomAction<Action> => ({
  type: 'setRecordAction',
  payload: param,
})

// 获取数据
export const getDataAction = (): CustomAction<Action> => ({
  type: 'getDataAction',
})

export const changeDataAction = (param: State): CustomAction<Action> => ({
  type: 'changeDataAction',
  payload: param,
})

export const setCountDataAction = (
  param: InquiryTabCountVO,
): CustomAction<Action> => ({
  type: 'setCountDataAction',
  payload: param,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (param: {
  dataSource: {
    data: InquiryOrderItemDTO[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 表格loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})

//
export const setCheckDataAction = (
  param: InquiryOrderItemDTO[],
): CustomAction<Action> => ({
  type: 'setCheckDataAction',
  payload: param,
})

export const setTagsDataAction = (param: Tag[]): CustomAction<Action> => ({
  type: 'setTagsDataAction',
  payload: param,
})

export const setStatusSearchDataAction = (
  param: number,
): CustomAction<Action> => ({
  type: 'setStatusSearchDataAction',
  payload: param,
})

// 用户搜索相关 actions

export const setImportModalOpenAction = (
  open: boolean,
): CustomAction<Action> => ({
  type: 'setImportModalOpenAction',
  payload: open,
})

export const setImportUploadListAction = (
  list: fileFile[],
): CustomAction<Action> => ({
  type: 'setImportUploadListAction',
  payload: list,
})

export const setImportOriginFileAction = (
  file?: RcFile,
): CustomAction<Action> => ({
  type: 'setImportOriginFileAction',
  payload: file,
})

export const setImportConfirmLoadingAction = (
  loading: boolean,
): CustomAction<Action> => ({
  type: 'setImportConfirmLoadingAction',
  payload: loading,
})
import { resetObj } from '@/tools/util'
import { ActionType, CustomAction } from '../../global'
import { InquiryOrderItemDTO, InquiryTabCountVO } from '@/api/inquiry'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'

export interface Tag {
  label: string
  value: string
  checked: boolean
  fieldKey: 'isUrgent' | 'isExpiringSoon' | 'isExpired'
}

export interface State {
  dataSource: {
    data: InquiryOrderItemDTO[]
    total: number
  }
  loading: boolean
  searchData: any
  pages: {
    pageNo: number
    pageSize: number
  }
  checkData: InquiryOrderItemDTO[]

  tagsData: Tag[]

  countData: InquiryTabCountVO
  record: InquiryOrderItemDTO

  // 状态筛选相关状态
  statusSearchData: number

  // 导入相关状态
  importModalOpen: boolean
  importUploadList: fileFile[]
  importOriginFile?: RcFile
  importConfirmLoading: boolean
}

export const initState: State = {
  dataSource: {
    data: [],
    total: 100,
  },
  loading: false,
  searchData: {},

  pages: {
    pageNo: 1,
    pageSize: 10,
  },
  checkData: [],

  tagsData: [
    {
      label: '急单🔥',
      value: '1',
      checked: false,
      fieldKey: 'isUrgent',
    },
    {
      label: '即将到期⚡️',
      value: '2',
      checked: false,
      fieldKey: 'isExpiringSoon',
    },
    {
      label: '已到期⚡️',
      value: '3',
      checked: false,
      fieldKey: 'isExpired',
    },
  ],

  countData: {
    unfinishedCount: 0,
    finishedCount: 0,
    totalCount: 0,
  } as InquiryTabCountVO,
  record: {} as InquiryOrderItemDTO,
  statusSearchData: 3,
  // 用户搜索相关状态

  importModalOpen: false,
  importUploadList: [],
  importOriginFile: undefined,
  importConfirmLoading: false,
}

type Action = ActionType<State> | 'getDataAction' | 'changeDataAction'

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    // 初始化数据
    case 'changeDataAction':
      return { ...action.payload }
    case 'getDataAction':
      newstate.pages.pageNo = 1
      newstate.pages.pageSize = 30
      newstate.searchData = resetObj(newstate.searchData)
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setPagesAction':
      newstate.pages = action.payload
      return newstate
    case 'setSearchDataAction':
      // 搜索 重置 分页
      newstate.searchData = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setCheckDataAction':
      newstate.checkData = action.payload
      return newstate

    case 'setTagsDataAction':
      newstate.tagsData = action.payload
      return newstate

    case 'setCountDataAction':
      newstate.countData = action.payload
      return newstate
    case 'setRecordAction':
      newstate.record = action.payload
      return newstate
    case 'setStatusSearchDataAction':
      newstate.statusSearchData = action.payload
      return newstate
    case 'setImportModalOpenAction':
      newstate.importModalOpen = action.payload
      return newstate
    case 'setImportUploadListAction':
      newstate.importUploadList = action.payload
      return newstate
    case 'setImportOriginFileAction':
      newstate.importOriginFile = action.payload
      return newstate
    case 'setImportConfirmLoadingAction':
      newstate.importConfirmLoading = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

export const setRecordAction = (
  param: InquiryOrderItemDTO,
): CustomAction<Action> => ({
  type: 'setRecordAction',
  payload: param,
})

// 获取数据
export const getDataAction = (): CustomAction<Action> => ({
  type: 'getDataAction',
})

export const changeDataAction = (param: State): CustomAction<Action> => ({
  type: 'changeDataAction',
  payload: param,
})

export const setCountDataAction = (
  param: InquiryTabCountVO,
): CustomAction<Action> => ({
  type: 'setCountDataAction',
  payload: param,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (param: {
  dataSource: {
    data: InquiryOrderItemDTO[]
    total: number
  }
  pageNo: number
}): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 表格loading
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

// 切换分页
export const setPagesAction = (param: {
  pageNo: number
  pageSize?: number
}): CustomAction<Action> => ({
  type: 'setPagesAction',
  payload: param,
})

// 搜索
export const setSearchDataAction = (param: any): CustomAction<Action> => ({
  type: 'setSearchDataAction',
  payload: param,
})

//
export const setCheckDataAction = (
  param: InquiryOrderItemDTO[],
): CustomAction<Action> => ({
  type: 'setCheckDataAction',
  payload: param,
})

export const setTagsDataAction = (param: Tag[]): CustomAction<Action> => ({
  type: 'setTagsDataAction',
  payload: param,
})

export const setStatusSearchDataAction = (
  param: number,
): CustomAction<Action> => ({
  type: 'setStatusSearchDataAction',
  payload: param,
})

// 用户搜索相关 actions

export const setImportModalOpenAction = (
  open: boolean,
): CustomAction<Action> => ({
  type: 'setImportModalOpenAction',
  payload: open,
})

export const setImportUploadListAction = (
  list: fileFile[],
): CustomAction<Action> => ({
  type: 'setImportUploadListAction',
  payload: list,
})

export const setImportOriginFileAction = (
  file?: RcFile,
): CustomAction<Action> => ({
  type: 'setImportOriginFileAction',
  payload: file,
})

export const setImportConfirmLoadingAction = (
  loading: boolean,
): CustomAction<Action> => ({
  type: 'setImportConfirmLoadingAction',
  payload: loading,
})
